import React, { useState } from "react";
import { Input, Stack, Textarea } from "@mui/joy";
import {
  COACHING_DOMAIN,
  coachingFaqApi,
  FAQ_LIST_ENDPOINT,
} from "api/coachingFaqApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import ButtonWithModal from "../../common/ButtonWithModal";
import Link from "../../common/Link";

export default function AddCoachingFaqButton() {
  const [question, setQuestion] = useState<string>("");
  const [answer, setAnswer] = useState<string>("");

  const queryClient = useQueryClient();

  const addMutation = useMutation({
    mutationFn: () => coachingFaqApi.add(question, answer),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [COACHING_DOMAIN, FAQ_LIST_ENDPOINT],
      });

      setQuestion("");
      setAnswer("");
    },
  });

  return (
    <>
      <ButtonWithModal
        buttonText={""}
        title="FAQ 추가"
        content={
          <Stack spacing={2}>
            <Input
              placeholder="자주 묻는 질문을 적어주세요."
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              sx={{
                borderColor: "background.level3",
                borderWidth: "1px",
                "--joy-focus-thickness": "0px",
                boxShadow: "0px 0px 0px transparent",
              }}
            />
            <Textarea
              placeholder="답변을 적어주세요."
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              minRows={3}
              sx={{
                borderColor: "background.level3",
                borderWidth: "1px",
                "--joy-focus-thickness": "0px",
                boxShadow: "0px 0px 0px transparent",
              }}
            />
          </Stack>
        }
        actionText="추가하기"
        cancelText="취소"
        action={() => addMutation.mutate()}
        actionButtonDisabled={
          addMutation.isLoading ||
          question.trim().length === 0 ||
          answer.trim().length === 0
        }
        loading={addMutation.isLoading}
        isWide={true}
        render={<Link text="+ 추가" opacity={1} textColor="primary.solid" />}
      />
    </>
  );
}